import type { UseFormReturn } from "react-hook-form";
import { Type } from "@themes/pollinator/ui/Type";
import { Form } from "@themes/pollinator/ui/Form";
import { FormField } from "@themes/pollinator/ui/FormField";

type SocialsFormData = {
  instagram_url?: string;
  facebook_url?: string;
  tiktok_url?: string;
  bluesky_url?: string;
  linkedin_url?: string;
};

export type Props = {
  /** react-hook-form instance */
  form: UseFormReturn<SocialsFormData>;
};

/**
 * Presentational org socials step.
 * Renders a form for editing the organization's social media URLs.
 */
export function OrgSocialsStep({ form }: Props) {
  return (
    <div className="flex-1 flex flex-col gap-6 p-6">
      <Type variant="h2">Social Media Accounts</Type>

      <div className="flex-1 flex flex-col justify-center gap-6">
        <Type variant="body1" className="text-brand-700">
          Add your organization's social media handles to help us
          connect with you.
        </Type>

        <Form form={form} errorContainerClassName="p-0 w-full max-w-full mt-8">
          <div className="flex flex-col gap-4">
            <FormField
              name="instagram_url"
              component="Input"
              prefix="instagram.com/"
              placeholder="username"
              size="default"
            />
            <FormField
              name="facebook_url"
              component="Input"
              prefix="facebook.com/"
              placeholder="page-name"
              size="default"
            />
            <FormField
              name="tiktok_url"
              component="Input"
              prefix="tiktok.com/"
              placeholder="@username"
              size="default"
            />
            <FormField
              name="bluesky_url"
              component="Input"
              prefix="bsky.app/profile/"
              placeholder="handle.bsky.social"
              size="default"
            />
            <FormField
              name="linkedin_url"
              component="Input"
              prefix="linkedin.com/company/"
              placeholder="company-name"
              size="default"
            />
          </div>
        </Form>
      </div>
    </div>
  );
}

export default OrgSocialsStep;
